import React, { useState } from "react";
import { Card, CardContent, Typography, Button, Box, CircularProgress } from "@mui/material";
import axiosInstance from '../common/axios';
import { useTranslation } from 'react-i18next';
import { normalizeKey } from '../i18n';




const SubscriptionCard = ({ user }) => {
  const [subscribed, setSubscribed] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { t } = useTranslation();
  
  const handleSubscribe = async () => {
    if (!user?.email) {
      setMessage("Please log in to subscribe.");
      return;
    }

    setLoading(true);
    try {
      // Example API call — replace endpoint with your actual one
      await axiosInstance.post("/api/subscribes/subscribe", { email: user.email });
      setSubscribed(true);
      setMessage("🎉 You’re now subscribed to weekly updates!");
    } catch (error) {
      console.error(error);
      setMessage("❌ Subscription failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleUnsubscribe = async () => {
    setLoading(true);
    try {
      await axiosInstance.post("/api/subscribes/unsubscribe", { email: user.email });
      setSubscribed(false);
      setMessage("You’ve unsubscribed from updates.");
    } catch (error) {
      console.error(error);
      setMessage("❌ Failed to unsubscribe. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
      <CardContent sx={{ textAlign: "center" }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
         {t('subscription' , 'Subscription')}  
        </Typography>

        <Typography variant="body2" sx={{ mb: 2 }}>
          {t('subscribe_to_our_weekly_updates_and_discounts' , 'Subscribe to our weekly updates and discounts:')} 
        </Typography>

        <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
          {user?.email || "No email available"}
        </Typography>

        <Box>
          {loading ? (
            <CircularProgress size={24} />
          ) : subscribed ? (
            <Button variant="outlined" color="secondary" onClick={handleUnsubscribe}>
              {t('unsubscribe' , 'Unsubscribe')}
            </Button>
          ) : (
            <Button variant="contained" color="primary" onClick={handleSubscribe}>
              {t('subscribe' , 'Subscribe')} 
            </Button>
          )}
        </Box>

        {message && (
          <Typography
            variant="caption"
            color={message.includes("❌") ? "error" : "success.main"}
            sx={{ display: "block", mt: 2 }}
          >
            {message}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default SubscriptionCard;
